import { debounce, cloneDeep } from "lodash";
import { submitDataToDb } from "./assessment";

export const saveDataToDb = debounce(
  (newQuiz, answers, assessment, onBack = false) => {
    const clonedAnswers = cloneDeep(answers);
    // data analysts asked to remove previous answer on going back.
    if (onBack) {
      clonedAnswers.pop();
    }

    submitDataToDb(clonedAnswers, assessment.questions, newQuiz.dbSlugs);
  },
  750
);
